import { TextAreaTemplate } from '@templates';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { useCycleStore } from '@cycle-hangars/store/store';
import { ErrorMessages } from '@types';
import { parseZodErrors, scrollTop, textAreaInputSchema } from '@utils';
import { ZodError } from 'zod';

export const Abandoned = () => {
  const { updateAbandondedTellUsMoreText, abandondedTellUsMoreText } =
    useCycleStore();
  const [textInput, setTextInput] = useState(abandondedTellUsMoreText);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();
  const MAX_LENGTH = 150;
  const pageTitle = 'Tell us which space in the cycle hangar the bike is in';
  const errorPath = 'abandonedTellUsMore';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextInput(event.target.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validatedData = textAreaInputSchema({
          fieldName: errorPath,
          requiredMessage: `Enter details about the bike’s location in the cycle hangar.`,
          maxLength: MAX_LENGTH,
          maxLengthMessage: `Information on the bike’s location in the cycle hangar must be 150 characters or less.`,
        }).parse({
          [errorPath]: textInput,
        });
        if (validatedData[errorPath]) {
          updateAbandondedTellUsMoreText(validatedData[errorPath]);
        }
        navigate(RoutesList.ABANDONED_OR_UNAUTHORISED_DESCRIBE);
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.ISSUE_SELECTION);
      scrollTop();
    },
  };

  return (
    <TextAreaTemplate
      initialTextValue={textInput}
      labelText={pageTitle}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={MAX_LENGTH}
      errorPath={errorPath}
      errorMessages={errorMessages}
    />
  );
};
